import { styled } from "@mui/material/styles";

export const BannerContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "block",
  width: "100%",
  padding: "5px 40px 5px 47px",
  color: "white",
  backgroundColor: theme.palette.primary.main,
  textAlign: "center",
  [theme.breakpoints.up("tablet")]: {
    textAlign: "left",
  },
  [theme.breakpoints.up("mobile")]: {
    height: 30,
    padding: "2px 40px 2px 47px",
  },
}));

export const Arrow = styled("div")(({ theme }) => ({
  position: "absolute",
  bottom: -4,
  left: "50%",
  marginLeft: -60,
  transform: "rotate(45deg)",
  width: 0,
  height: 0,
  borderLeft: "6px solid transparent",
  borderRight: "6px solid transparent",
  borderBottom: `6px solid ${theme.palette.primary.main}`,
  [theme.breakpoints.up("tablet")]: {
    left: "auto",
    marginLeft: 0,
  },
}));
